import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { DashboardComponent } from './dashboard.component';
import { MatSelectModule } from '@angular/material/select';
import { NgSelectModule } from '@ng-select/ng-select';
import { ReactiveFormsModule } from '@angular/forms';
import { MatExpansionModule } from '@angular/material/expansion';


const routes: Routes = [{
  path: '',
  children:[
    {path:'',component:DashboardComponent},
    {path:'**', redirectTo:'', pathMatch:'full'}
  ]
}];

@NgModule({
  declarations: [DashboardComponent],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    MatSelectModule,
    NgSelectModule,
    ReactiveFormsModule,
    MatExpansionModule
  ]
})
export class DashboardModule { }
